import React, { FC } from 'react';
import cx from 'classnames';

import PaginationLink from './PaginationLink';

import styles from './pagination.module.scss';

interface IProps {
  totalPages: number;
  currentPage: number;
  className?: string;
  linkRenderer?: (page: number) => string;
}

const Pagination: FC<IProps> = ({
  totalPages,
  currentPage,
  className,
  linkRenderer,
}) => {
  if (totalPages < 2) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  /* TODO: 9 is max for mobile, add dots? */

  return (
    <div className={cx(styles.container, className)} id="pagination">
      <PaginationLink
        isPrev
        page={currentPage - 1}
        isDisabled={(currentPage - 1) < 1}
        linkRenderer={linkRenderer}
        ariaLabel="Previous page"
      />
      {pages.map((page: number) => (
        <PaginationLink
          key={page}
          page={page}
          isSelected={page === currentPage}
          linkRenderer={linkRenderer}
        />
      ))}
      <PaginationLink
        isNext
        page={currentPage + 1}
        isDisabled={(currentPage + 1) > totalPages}
        linkRenderer={linkRenderer}
        ariaLabel="Next page"
      />
    </div>
  );
};

export default Pagination;
